import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { Observable, finalize } from 'rxjs';
import { IGetInstagramPostsData } from '../../Models/IInstagramPost';
import {faExternalLink} from '@fortawesome/free-solid-svg-icons';
import { InstagramCommentDto, IInstagramComment } from '../../Models/IInstagramComment';
import { HelperFunctions } from '../../../../helpers/HelperFunctions';
import { InstagramService } from '../../Services/instagram.service';
import { IInstagramPolitician } from '../../Models/IInstagramPolitician';

@Component({
  selector: 'app-instagram-post-details',
  templateUrl: './instagram-post-details.component.html',
  styleUrls: ['./instagram-post-details.component.scss']
})
export class InstagramPostDetailsComponent implements OnInit {
  @Input() postId?: string;
  attackedPoliticianDetails: IInstagramPolitician | null = null;
  postDetails: IGetInstagramPostsData | null = null;
  comments: Array<IInstagramComment> = [];
  isLoading = false;
  error: string = '';

  //icons
  faExternalLink = faExternalLink;

  constructor(
    private drawerRef: NzDrawerRef<InstagramPostDetailsComponent>,
    private instagramService: InstagramService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.postId)
      this.loadPostDetails();
    else
      this.error = 'No post ID provided';
  }

  loadPostDetails(): void {
    this.isLoading = true;
    this.error = '';
    
    this.instagramService.getPostDetails(this.postId as string)
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.cdr.detectChanges(); // Force change detection
        })
      )
      .subscribe({
        next: (response: IGetInstagramPostsData) => {
          console.log('Post details received:', response);
          this.postDetails = response;
          
          // Check if postDetails has the required properties
          if (!this.postDetails || typeof this.postDetails !== 'object') {
            this.error = 'Invalid response format received';
          }
        },
        error: (error) => {
          this.error = 'Failed to load post details. Please try again.';
        }
      });
  }

  formatDatetime(time: string): string {
    return HelperFunctions.formatDatetime(time);
  }
  

  close(): void {
    this.drawerRef.close();
  }
}